import { Application } from '../types'

export const applications: Application[] = [
  {
    id: 'construction',
    title: 'Građevinski objekti',
    titleEn: 'Construction sites',
    titleRu: 'Строительные объекты',
    problem:
      'Ručni transport materijala uz stepenice usporava radove i povećava rizik od povreda i oštećenja opreme.',
    problemEn:
      'Manual transport of materials up stairs slows down work and increases the risk of injury and equipment damage.',
    problemRu:
      'Ручная транспортировка материалов по лестницам замедляет работы и увеличивает риск травм и повреждения оборудования.',
    solution:
      'D-TECH električna mašina za transport tereta omogućava bezbedno podizanje tereta do 250 kg uz potpunu kontrolu i stabilnost, ubrzavajući dinamiku gradilišta i smanjujući opterećenje radnika.',
    solutionEn:
      'The D-TECH electric cargo transport machine allows safe lifting of loads up to 250 kg with full control and stability, accelerating site dynamics and reducing worker strain.',
    solutionRu:
      'Электрическая машина D-TECH для транспортировки грузов позволяет безопасно поднимать грузы до 250 кг с полным контролем и устойчивостью, ускоряя динамику стройплощадки и снижая нагрузку на работников.',
    icon: 'HardHat',
  },
  {
    id: 'warehousing',
    title: 'Magacini i distribucija',
    titleEn: 'Warehousing and distribution',
    titleRu: 'Склады и дистрибуция',
    problem:
      'Kretanje robe između spratova u objektima bez teretnog lifta stvara zastoje i povećava troškove radne snage.',
    problemEn:
      'Moving goods between floors in buildings without a freight elevator creates bottlenecks and increases labor costs.',
    problemRu:
      'Перемещение товаров между этажами в зданиях без грузового лифта создаёт задержки и увеличивает затраты на рабочую силу.',
    solution:
      'Optimizujte vertikalni transport robe pouzdanim električnim transporterom koji omogućava jednoj osobi da bezbedno prenosi teške terete bez dodatne radne snage.',
    solutionEn:
      'Optimize vertical cargo transport with a reliable electric transporter that allows one person to safely carry heavy loads without additional manpower.',
    solutionRu:
      'Оптимизируйте вертикальную транспортировку товаров надёжным электрическим транспортёром, который позволяет одному человеку безопасно перевозить тяжёлые грузы без дополнительной рабочей силы.',
    icon: 'Package',
  },
  {
    id: 'delivery',
    title: 'Dostava i kurirske službe',
    titleEn: 'Delivery and courier services',
    titleRu: 'Доставка и курьерские службы',
    problem:
      'Isporuka bele tehnike, opreme i paketa u višespratnim zgradama je fizički zahtevna i rizična.',
    problemEn:
      'Delivering white goods, equipment, and packages in multi-story buildings is physically demanding and risky.',
    problemRu:
      'Доставка бытовой техники, оборудования и посылок в многоэтажных зданиях физически тяжёлая и рискованная.',
    solution:
      'Električni transporter za stepenice omogućava kontrolisano kretanje tereta uz i niz stepenice, smanjujući rizik od povreda i oštećenja robe.',
    solutionEn:
      'The electric stair climber enables controlled movement of cargo up and down stairs, reducing the risk of injury and goods damage.',
    solutionRu:
      'Электрический лестничный транспортёр обеспечивает контролируемое перемещение грузов вверх и вниз по лестницам, снижая риск травм и повреждения товаров.',
    icon: 'Truck',
  },
  {
    id: 'manufacturing',
    title: 'Proizvodni pogoni',
    titleEn: 'Manufacturing facilities',
    titleRu: 'Производственные объекты',
    problem:
      'Premeštanje sirovina i gotovih proizvoda između proizvodnih nivoa usporava operacije i stvara uska grla.',
    problemEn:
      'Moving raw materials and finished products between production levels slows down operations and creates bottlenecks.',
    problemRu:
      'Перемещение сырья и готовой продукции между производственными уровнями замедляет операции и создаёт узкие места.',
    solution:
      'D-TECH mašina za vertikalni transport obezbeđuje stabilan i kontinualan tok materijala između nivoa bez prekida proizvodnje.',
    solutionEn:
      'The D-TECH vertical transport machine ensures a stable and continuous flow of materials between levels without interrupting production.',
    solutionRu:
      'Машина D-TECH для вертикальной транспортировки обеспечивает стабильный и непрерывный поток материалов между уровнями без остановки производства.',
    icon: 'Factory',
  },
  {
    id: 'retail',
    title: 'Maloprodaja i HoReCa',
    titleEn: 'Retail and HoReCa',
    titleRu: 'Розничная торговля и HoReCa',
    problem:
      'Dopuna zaliha u višespratnim objektima opterećuje osoblje i usporava rad.',
    problemEn:
      'Restocking supplies in multi-story facilities burdens staff and slows down work.',
    problemRu:
      'Пополнение запасов в многоэтажных объектах нагружает персонал и замедляет работу.',
    solution:
      'Kompaktna konstrukcija i precizna kontrola omogućavaju brzo i bezbedno premeštanje robe kroz uske prolaze i stepenice bez ometanja kupaca.',
    solutionEn:
      'Compact design and precise control allow fast and safe movement of goods through narrow aisles and stairs without disturbing customers.',
    solutionRu:
      'Компактная конструкция и точное управление обеспечивают быстрое и безопасное перемещение товаров через узкие проходы и лестницы без помех для покупателей.',
    icon: 'Store',
  },
  {
    id: 'healthcare',
    title: 'Zdravstvene ustanove',
    titleEn: 'Healthcare facilities',
    titleRu: 'Медицинские учреждения',
    problem:
      'Transport osetljive medicinske opreme zahteva maksimalnu stabilnost i kontrolu.',
    problemEn:
      'Transporting sensitive medical equipment requires maximum stability and control.',
    problemRu:
      'Транспортировка чувствительного медицинского оборудования требует максимальной устойчивости и контроля.',
    solution:
      'Električna mašina sa integrisanom kočnicom obezbeđuje siguran i kontrolisan transport osetljive opreme kroz više nivoa objekta.',
    solutionEn:
      'The electric machine with an integrated brake ensures safe and controlled transport of sensitive equipment across multiple facility levels.',
    solutionRu:
      'Электрическая машина со встроенным тормозом обеспечивает безопасную и контролируемую транспортировку чувствительного оборудования через несколько уровней объекта.',
    icon: 'Heart',
  },
]
